<template>
  <div>
    <AddressHeader :clientInfo="clientInfo" />
    <SimpleQuarterTable :card="card"
                        fieldName="InControl"
                        headerText="In Control Erfüllungsrate"
                        :selectedQuarter="quarter"
                        :selectedYear="year" />
    <HeaderLine :title="$t('Webportal.CX.MonthlyConsideration')" />
    <InControlDetailsTable  :brand="brand" 
                            :card="card" 
                            :detailItems="getDetailItems()" 
                            :thresholds="thresholds" />
  </div>
</template>

<script>
import AddressHeader from '@/components/CX/DashboardCards/AddressHeader.vue';
import SimpleQuarterTable from '@/components/CX/DashboardCards/SimpleQuarterTable.vue';
import InControlDetailsTable from '@/components/CX/DashboardCards/InControlDetailsTable.vue';
import HeaderLine from '@/components/CX/DashboardCards/HeaderLine.vue';

export default {
  components: {
    AddressHeader, SimpleQuarterTable, InControlDetailsTable, HeaderLine
  },

  props: {
    brand:              { type: String, required: true },
    card:               { type: Object, default: undefined },
    clientInfo:         { type: Object, default: undefined },
    quarter:            { type: Number, default: undefined },
    thresholds:         { type: Array, required: true },
    year:               { type: Number, default: undefined }
  },

  methods: {
    getDetailItems() {
      if (!this.card || !this.card.details) return [];
      // get all detail items where the year and quarter matches
      let items = this.card.details.filter(x => x.Year === this.year && x.Quarter === this.quarter);
      // sort by handover date
      items.sort((a, b) => {
        return new Date(a.HandOver) - new Date(b.HandOver);
      });
      return items;
    }
  }
}
</script>